export const PROBABILITY_TYPES = {
  high: 'высокие',
  medium: 'средние',
  low: 'низкие',
  middle: 'средние',
}

export const HEAD_COLORS = {
  noSuitablePrograms: {
    box: 'silver',
    heading: 'black',
  },
  high: {
    box: 'lime',
    heading: 'emerald',
  },
  medium: {
    box: 'yellow',
    heading: 'orange',
  },
  low: {
    box: 'rose50',
    heading: 'red',
  },
} as const
